import { render, staticRenderFns } from "./CustomizeApp.vue?vue&type=template&id=7cbec350&"
import script from "./CustomizeApp.vue?vue&type=script&lang=js&"
export * from "./CustomizeApp.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports